import html2canvas from 'html2canvas';
import { imageSize, windowSize } from '../config/thumbnailSize';

// TODO  #002 move to engagement-ui @sinslav
const canvasToImageBlob = canvas =>
  new Promise(resolve => {
    canvas.toBlob(
      blob => {
        resolve(blob);
      },
      'image/jpeg',
      0.85,
    );
  });

export const nodeToImageBlob = async node => {
  const canvas = await html2canvas(node, {
    windowWidth: windowSize.width,
    windowHeight: windowSize.height,
    width: imageSize.width,
    height: imageSize.height,
    scale: 0.5,
    scrollX: 0,
    scrollY: 0,
    useCORS: true,
    logging: false,
    removeContainer: false,
  });
  return canvasToImageBlob(canvas);
};
